import "./converter.css";
import ConverterContiner from "./ConverterContiner";


export default function AppConverter ({}) {

    return(
        <div className="Converter">

            <p> סכום </p>
            <p> מ... </p>
            <p> </p>
            <p> ל... </p>
            <p>תוצאה</p>

            <ConverterContiner 
            fromName={"ILS - Israeli Shekel"}
            fromSymbol={"₪"}
            toName={"USD - US Dollar"}
            toSymbol={"$"}
            />

            <ConverterContiner 
            fromName={"USD - US Dollar"}
            fromSymbol={"$"}
            toName={"ILS - Israeli Shekel"}
            toSymbol={"₪"}
            />

            <ConverterContiner 
            fromName={"EUR - Euro"}
            fromSymbol={"€"}
            toName={"ILS - Israeli Shekel"}
            toSymbol={"₪"}
            />

        </div>
    )
}